import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { faMicrophone } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { COLOR_GREEN } from "../../common/colors";

export enum ListeningMode {
  IDLE = 1,
  WAITING_FOR_VOICE_ACTIVITY,
  SPEAKING,
  NOT_SPEAKING,
}

const LINE_HEIGHT = 4;
const LINE_WIDTH_SPEAKING = 60;
const LINE_WIDTH_NOT_SPEAKING = LINE_HEIGHT;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

const Line = styled.div`
  height: ${LINE_HEIGHT}px;
  background-color: ${COLOR_GREEN};
  transition: width 0.25s ease;
  border-radius: ${LINE_HEIGHT / 2}px;
`;

export const ListeningAnimation = ({ mode }) => {
  const [lineWidth, setLineWidth] = useState(0);

  useEffect(() => {
    switch (mode) {
      case ListeningMode.SPEAKING:
        setLineWidth(LINE_WIDTH_SPEAKING);
        break;
      case ListeningMode.NOT_SPEAKING:
        setLineWidth(LINE_WIDTH_NOT_SPEAKING);
        break;
      case ListeningMode.WAITING_FOR_VOICE_ACTIVITY:
        setLineWidth(LINE_HEIGHT);
        break;
      case ListeningMode.IDLE:
        setLineWidth(0);
        break;
    }
  }, [mode]);

  return (
    <Container>
      <Line
        style={{
          width: `${lineWidth}px`,
          visibility: mode === ListeningMode.IDLE ? "hidden" : "visible",
        }}
      ></Line>
      <FontAwesomeIcon
        icon={faMicrophone}
        size="2x"
        color={COLOR_GREEN}
        style={{
          visibility: mode === ListeningMode.IDLE ? "hidden" : "visible",
        }}
      />
      <Line
        style={{
          width: `${lineWidth}px`,
          visibility: mode === ListeningMode.IDLE ? "hidden" : "visible",
        }}
      ></Line>
    </Container>
  );
};
